module.exports = __webpack_public_path__ + "static/img/年度最佳电竞手机.b2158e2a.png";